import { flattenMessages } from '../helper/flattenMessages.ts';

import { de } from './de-DE/message.ts';
import { en } from './en-GB/message.ts';
import { es } from './es-ES/message.ts';
import { it } from './it-IT/message.ts';
import { LOCALES } from './locales';
import { ru } from './ru-RU/message.ts';
import { tr } from './tr-TR/message.ts';
import { uk } from './uk-UA/message.ts';

export const messages = {
  [LOCALES.en]: flattenMessages(en),
  [LOCALES.ru]: flattenMessages(ru),
  [LOCALES.uk]: flattenMessages(uk),
  [LOCALES.it]: flattenMessages(it),
  [LOCALES.de]: flattenMessages(de),
  [LOCALES.tr]: flattenMessages(tr),
  [LOCALES.es]: flattenMessages(es)
};
